// Sheep override (grazer + wool regrow, M13.1). PURE (ENG-1).
//
// Ordinary grazer behaviour, plus: a sheared sheep standing on grass slowly eats
// and regrows its wool (so it can be sheared again). Shearing + the colour variant
// itself are driven by the player interaction in boot (game.useEntity).
import { SHEEP } from '../../config';
import type { MobDef } from '../../registry/schemas';
import type { Entity, MobContext } from '../entity';
import { grazer } from '../archetypes/grazer';
import { woolVariant } from '../../heredity/express';

export function sheep(e: Entity, def: MobDef, ctx: MobContext): void {
  grazer(e, def, ctx);
  // §28.6: under the rule the wool_growth gene divides the regrow odds. `regrowMul` is 1
  // with the rule off, and the draw is the same ONE `nextInt` either way — only its bound
  // moves — so a rule-off sheep consumes exactly the stream it always did.
  const genetic = e.genome !== undefined && ctx.sys.heredityIsOn();
  const denom = genetic ? Math.max(1, Math.round(SHEEP.REGROW_DENOM / e.traits.regrowMul)) : SHEEP.REGROW_DENOM;
  if (
    e.sheared &&
    ctx.world.isGrass?.(Math.floor(e.x), Math.floor(e.y) - 1, Math.floor(e.z)) &&
    ctx.rng.nextInt(denom) === 0
  ) {
    e.sheared = false; // ate grass → wool grows back
    // …in its NATURAL colour under the rule: a dye does not survive the regrow (§28.6,
    // D-TF-134). Off, the dyed colour stays, as it always has.
    if (genetic) {
      const natural = woolVariant(def.genes, e.genome);
      if (natural !== undefined) e.variant = natural;
    }
  }
}
